import React, { useEffect, useState, useRef, memo, createElement, Component } from 'react';
import { CheckCircle2, ShieldCheck, Star, ChevronDown, ChevronUp, ChevronLeft, ChevronRight, X, Download, Lock, Heart, Users, Sparkles, CheckCircle, ArrowRight, Calendar, Home, Church, GraduationCap, Zap, RefreshCw, FileText } from 'lucide-react';
// --- Meta Pixel Hook ---
const useMetaPixel = () => {
  useEffect(() => {
    // Evitar duplicados
    if (typeof window === 'undefined') return;
    if ((window as any).fbq) {
      console.log('✅ Meta Pixel ya estaba inicializado');
      return;
    }
    // Inicializar fbq antes de cargar el script
    const f = window as any;
    const n: any = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    // Crear y cargar el script
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    script.onload = () => {
      console.log('✅ Meta Pixel script cargado correctamente');
    };
    script.onerror = () => {
      console.error('❌ Error al cargar Meta Pixel script');
    };
    // Insertar el script
    const firstScript = document.getElementsByTagName('script')[0];
    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript);
    } else {
      document.head.appendChild(script);
    }
    // Inicializar el pixel con tu ID
    ;
    (window as any).fbq('init', '2127577624668038');
    (window as any).fbq('track', 'PageView');
    console.log('✅ Meta Pixel inicializado - ID: 2127577624668038');
    console.log('✅ PageView tracked');
    // Agregar noscript fallback
    const noscriptImg = document.createElement('img');
    noscriptImg.height = 1;
    noscriptImg.width = 1;
    noscriptImg.style.display = 'none';
    noscriptImg.src = 'https://www.facebook.com/tr?id=2127577624668038&ev=PageView&noscript=1';
    noscriptImg.alt = '';
    document.body.appendChild(noscriptImg);
  }, []);
};
// --- Constants ---
const IMAGES = {
  product: 'https://cdn.magicpatterns.com/uploads/iPp2zpYKjLVjDi6wG8wUkg/Generated_Image_February_01__2026_-_11_41PM-removebg-preview.png',
  bonus1: 'https://cdn.magicpatterns.com/uploads/9CWjz6HTJgD5o31zdUHYhw/Bono_1.png',
  bonus2: 'https://cdn.magicpatterns.com/uploads/psXyq6tY7w8juckHNCdfCk/Bono_2.png',
  bonus3: 'https://cdn.magicpatterns.com/uploads/5mm9SeTmqD17zbu92YRvnD/Bono_3.png',
  mercadoLibre: 'https://cdn.magicpatterns.com/uploads/vCqn3onscPd2AoBHsET1mU/logo_ML.jpg',
  carousel: ['https://cdn.magicpatterns.com/uploads/gdRMEPrAJDmgVzLySy7RDT/parabo_3.jpg', 'https://cdn.magicpatterns.com/uploads/mfLGG6Ncvq4iR6TLY2s1WF/parabo_4.jpg', 'https://cdn.magicpatterns.com/uploads/xB3s9AAzYcTG53DsCj4h4e/parabo_5.jpg', 'https://cdn.magicpatterns.com/uploads/8Xqb2kXVBDDvikRFDNu4Lx/parabo_6.jpg']
};
const TESTIMONIALS = [{
  name: 'María González',
  role: 'Madre de 3 hijos',
  city: 'Córdoba',
  initials: 'MG',
  highlight: 'Momentos únicos en familia',
  text: 'Mis hijos ahora me piden que les lea una parábola antes de dormir. Es hermoso ver cómo aprenden valores sin darse cuenta. ¡Gracias por este material tan lindo!'
}, {
  name: 'Patricia Rodríguez',
  role: 'Catequista',
  city: 'Buenos Aires',
  initials: 'PR',
  highlight: 'Todo el año resuelto',
  text: 'Me salvó la planificación del año. Las historias son cortas, claras y a los chicos les encantan los dibujos. Ya no improviso más.'
}, {
  name: 'Laura Fernández',
  role: 'Docente de primaria',
  city: 'Mendoza',
  initials: 'LF',
  highlight: 'Material de primer nivel',
  text: 'Un recurso pedagógico excelente. Lo uso en mis clases de formación ética y cristiana. Los niños participan mucho más.'
}, {
  name: 'Carolina Martínez',
  role: 'Madre y educadora',
  city: 'Rosario',
  initials: 'CM',
  highlight: 'Paz y herramientas',
  text: 'La calidad del material es excelente. Me da mucha paz tener herramientas lindas para hablar de Dios con mis hijos.'
}, {
  name: 'Gabriela López',
  role: 'Catequista parroquial',
  city: 'Tucumán',
  initials: 'GL',
  highlight: 'Lo que buscaba hace años',
  text: 'Buscaba algo así hace años. Es práctico, lindo y muy profundo. Los chicos se enganchan enseguida.'
}];
const FAQS = [{
  q: '¿Es digital o físico?',
  a: 'Es 100% digital. Recibís acceso inmediato para descargar todo el material en PDF de alta calidad, listo para imprimir o usar en pantalla.'
}, {
  q: '¿Cuándo recibo el material?',
  a: 'Inmediatamente después del pago. Te llega un email con el acceso a la plataforma donde podés descargar todo.'
}, {
  q: '¿Sirve para catequesis, escuela y familia?',
  a: '¡Sí! Está pensado para usarse en los tres contextos. Podés adaptarlo según tu necesidad.'
}, {
  q: '¿Para qué edades funciona?',
  a: 'Principalmente para niños de 3 a 10 años. El lenguaje es simple para los más chiquitos, pero las reflexiones son profundas para los más grandes.'
}, {
  q: '¿Necesito experiencia previa?',
  a: 'No. El material está diseñado para que cualquier persona pueda usarlo, incluso sin experiencia pedagógica.'
}, {
  q: '¿Qué medios de pago aceptan?',
  a: 'Aceptamos tarjetas de crédito, débito y Mercado Pago. El pago es 100% seguro.'
}, {
  q: '¿Qué cubre la garantía?',
  a: 'Tenés 7 días para probar el material. Si no te gusta por cualquier razón, te devolvemos el 100% de tu dinero sin preguntas.'
}];
const CONTENT_AXES = [{
  emoji: '❤️',
  title: 'Amor al Prójimo',
  desc: 'Empatía, respeto y cuidado del otro.'
}, {
  emoji: '🙏',
  title: 'Fe y Confianza en Dios',
  desc: 'Fortalecer la relación con Dios.'
}, {
  emoji: '🎯',
  title: 'Obediencia y Buenas Decisiones',
  desc: 'Guiar conductas y elecciones.'
}, {
  emoji: '💖',
  title: 'Perdón y Nuevos Comienzos',
  desc: 'Segundas oportunidades y reconciliación.'
}, {
  emoji: '🌟',
  title: 'Valentía con Jesús',
  desc: 'Fe y coraje en momentos difíciles.'
}, {
  emoji: '🤝',
  title: 'Amistad y Compasión',
  desc: 'Vínculos sanos y convivencia.'
}, {
  emoji: '📘',
  title: 'Respeto y Buena Educación',
  desc: 'Normas, hábitos y convivencia.'
}, {
  emoji: '🎁',
  title: 'Bondad y Generosidad',
  desc: 'Valores solidarios y dar sin esperar.'
}, {
  emoji: '🌱',
  title: 'Gratitud y Contentamiento',
  desc: 'Mirada agradecida y valorar lo que tenemos.'
}, {
  emoji: '👣',
  title: 'Siguiendo los Pasos de Jesús',
  desc: 'Formación cristiana integral.'
}];
const SOCIAL_PROOF = [{
  name: 'Luciana',
  city: 'La Plata'
}, {
  name: 'Martín',
  city: 'Mar del Plata'
}, {
  name: 'Sofía',
  city: 'Salta'
}, {
  name: 'Diego',
  city: 'Neuquén'
}, {
  name: 'Valeria',
  city: 'Santa Fe'
}, {
  name: 'Andrea',
  city: 'Corrientes'
}];
// --- Components ---
const CTAButton = ({
  children,
  variant = 'primary',
  className = '',
  small = false
}: {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  className?: string;
  small?: boolean;
}) => {
  const scrollToCheckout = () => {
    document.getElementById('seccion-compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const baseClass = variant === 'primary' ? 'cta-button' : 'cta-secondary';
  const sizeClass = small ? 'py-3 px-6 text-base' : 'py-4 px-8 text-lg';
  return <button onClick={scrollToCheckout} className={`${baseClass} w-full ${sizeClass} rounded-xl font-bold text-white flex flex-col items-center justify-center ${className}`} data-id="element-1">
      {children}
    </button>;
};
// Botón de checkout externo (solo para la sección de compra)
const CheckoutButton = ({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  const handleCheckout = () => {
    window.open('https://checkout.pixastore.online/cart/42435920822366:1', '_blank');
  };
  return <button onClick={handleCheckout} className={`cta-button w-full py-4 px-8 text-lg rounded-xl font-bold text-white flex flex-col items-center justify-center ${className}`} data-id="element-2">
      {children}
    </button>;
};
const TrustBadges = ({
  dark = false
}: {
  dark?: boolean;
}) => <div className={`flex items-center justify-center gap-6 text-sm mt-4 ${dark ? 'text-blue-200' : 'text-gray-500'}`} data-id="element-3">
    <div className="flex items-center gap-1.5" data-id="element-4">
      <Download className="w-4 h-4" data-id="element-5" />
      <span data-id="element-6">Descarga inmediata</span>
    </div>
    <div className="flex items-center gap-1.5" data-id="element-7">
      <ShieldCheck className="w-4 h-4" data-id="element-8" />
      <span data-id="element-9">Garantía 7 días</span>
    </div>
    <div className="flex items-center gap-1.5" data-id="element-10">
      <Lock className="w-4 h-4" data-id="element-11" />
      <span data-id="element-12">Pago seguro</span>
    </div>
  </div>;
const SocialProofPopup = () => {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState(SOCIAL_PROOF[0]);
  useEffect(() => {
    const showPopup = () => {
      const randomData = SOCIAL_PROOF[Math.floor(Math.random() * SOCIAL_PROOF.length)];
      setData(randomData);
      setVisible(true);
      setTimeout(() => setVisible(false), 4000);
    };
    const initialTimeout = setTimeout(showPopup, 10000);
    const interval = setInterval(showPopup, 25000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  if (!visible) return null;
  return <div className="fixed bottom-4 right-4 bg-white rounded-lg shadow-2xl p-4 border border-gray-200 z-50 max-w-xs animate-in slide-in-from-bottom-5 fade-in duration-300" data-id="element-13">
      <div className="flex items-center gap-3" data-id="element-14">
        <div className="bg-green-100 p-2 rounded-full" data-id="element-15">
          <CheckCircle2 className="w-5 h-5 text-green-600" data-id="element-16" />
        </div>
        <div data-id="element-17">
          <p className="text-sm font-bold text-gray-800" data-id="element-18">
            {data.name} de {data.city}
          </p>
          <p className="text-xs text-gray-500" data-id="element-19">Compró 1001 Parábolas Kids</p>
          <p className="text-xs text-green-600 font-medium" data-id="element-20">hace 3 minutos</p>
        </div>
      </div>
    </div>;
};
// Carousel Component with arrows
const ImageCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const totalSlides = IMAGES.carousel.length;
  const goToPrevious = () => {
    setCurrentIndex(prev => prev === 0 ? totalSlides - 1 : prev - 1);
  };
  const goToNext = () => {
    setCurrentIndex(prev => prev === totalSlides - 1 ? 0 : prev + 1);
  };
  return <div className="relative max-w-md mx-auto" data-id="element-21">
      {/* Main Image */}
      <div className="relative overflow-hidden rounded-xl shadow-lg border-4 border-white" data-id="element-22">
        <img src={IMAGES.carousel[currentIndex]} alt={`Muestra ${currentIndex + 1}`} className="w-[80%] h-auto mx-auto cursor-pointer" onClick={() => document.getElementById('seccion-compra')?.scrollIntoView({
        behavior: 'smooth'
      })} data-id="element-23" />
      </div>

      {/* Navigation Arrows */}
      <button onClick={goToPrevious} className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 bg-white rounded-full p-2 shadow-lg hover:bg-gray-50 transition-colors z-10" aria-label="Anterior" data-id="element-24">
        <ChevronLeft className="w-6 h-6 text-[#1e3a5f]" data-id="element-25" />
      </button>
      <button onClick={goToNext} className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 bg-white rounded-full p-2 shadow-lg hover:bg-gray-50 transition-colors z-10" aria-label="Siguiente" data-id="element-26">
        <ChevronRight className="w-6 h-6 text-[#1e3a5f]" data-id="element-27" />
      </button>

      {/* Dots Indicator */}
      <div className="flex justify-center gap-2 mt-4" data-id="element-28">
        {IMAGES.carousel.map((_, i) => <button key={i} onClick={() => setCurrentIndex(i)} className={`w-2.5 h-2.5 rounded-full transition-colors ${i === currentIndex ? 'bg-[#1e3a5f]' : 'bg-gray-300'}`} aria-label={`Ir a imagen ${i + 1}`} data-id="element-29" />)}
      </div>
    </div>;
};
export function LandingPage() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  // Inicializar Meta Pixel
  useMetaPixel();
  return <div className="min-h-screen bg-[#faf8f5]" data-id="element-30">
      {/* ===== SECTION 1: HERO ===== */}
      <section className="bg-gradient-to-b from-[#e8f4fc] to-[#faf8f5] pt-6 pb-6 px-4" data-id="element-31">
        <div className="max-w-4xl mx-auto text-center" data-id="element-32">
          {/* Stars */}
          <div className="flex items-center justify-center gap-1 mb-2" data-id="element-33">
            {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-34" />)}
            <span className="text-sm text-gray-600 ml-2" data-id="element-35">
              +500 familias felices
            </span>
          </div>

          {/* Title */}
          <h1 className="text-3xl md:text-5xl font-black text-[#1e3a5f] leading-tight mb-2" data-id="element-36">
            1001 Parábolas Kids
          </h1>

          {/* Promise - NEW */}
          <p className="text-xl md:text-2xl font-bold text-[#2563eb] mb-3 max-w-2xl mx-auto" data-id="element-37">
            Todo lo que necesitás para enseñar Valores y Fe a los niños. Un año
            completo, listo para usar.
          </p>

          {/* Emotional phrase */}
          <p className="text-base md:text-lg text-[#1e3a5f] font-medium mb-4 max-w-2xl mx-auto" data-id="element-38">
            "Guía con cariño y dejá huellas de valores que perduren para siempre
            en el corazón de los niños."
          </p>

          {/* Mockup - MEDIUM size */}
          <div className="relative mx-auto w-full max-w-[320px] mb-4" data-id="element-39">
            <img src={IMAGES.product} alt="1001 Parábolas Kids" className="w-full h-auto drop-shadow-xl animate-float cursor-pointer" onClick={() => document.getElementById('seccion-compra')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-40" />
          </div>

          {/* Subtitle */}
          <p className="text-sm md:text-base text-gray-600 mb-5 max-w-2xl mx-auto leading-relaxed" data-id="element-41">
            Historias bíblicas ilustradas y adaptadas para niños, pensadas para
            padres, catequistas y docentes que quieren algo más que entretener:{' '}
            <strong data-id="element-42">
              educar en la fe, crear momentos significativos y dejar un legado
            </strong>{' '}
            — con todo el contenido ya organizado para todo el año.
          </p>

          {/* CTA - Adjusted: smaller with subtext inside */}
          <div className="max-w-sm mx-auto" data-id="element-43">
            <CTAButton small data-id="element-44">
              <span className="flex items-center gap-2" data-id="element-45">
                <span data-id="element-46">👉</span> QUIERO MI KIT AHORA{' '}
                <ArrowRight className="w-5 h-5" data-id="element-47" />
              </span>
              <span className="text-xs font-normal opacity-90 mt-1" data-id="element-48">
                Acceso inmediato – Garantía de 7 días
              </span>
            </CTAButton>
            <TrustBadges data-id="element-49" />
          </div>
        </div>
      </section>

      {/* ===== SECTION 2: PAIN POINTS ===== */}
      <section className="py-8 px-4 bg-[#faf8f5]" data-id="element-50">
        <div className="max-w-3xl mx-auto" data-id="element-51">
          <h2 className="text-2xl md:text-3xl font-bold text-center text-[#1e3a5f] mb-6" data-id="element-52">
            Si acompañás niños en la fe, probablemente te pasa esto…
          </h2>

          <div className="bg-white rounded-2xl shadow-lg p-5 md:p-6 border border-gray-100" data-id="element-53">
            <ul className="space-y-3" data-id="element-54">
              {['Querés enseñar valores, pero cuesta explicarlos de forma simple y atractiva.', 'Buscás material… y todo lo que encontrás es viejo o poco claro.', 'Se te hace difícil mantener la atención de los chicos sin aburrirlos.', 'Perdés horas preparando cada encuentro.', 'Terminás improvisando porque no tenés un plan ordenado.'].map((pain, i) => <li key={i} className="flex items-start gap-3" data-id="element-55">
                  <div className="bg-red-100 p-1 rounded-full mt-0.5" data-id="element-56">
                    <X className="w-4 h-4 text-red-500" data-id="element-57" />
                  </div>
                  <span className="text-gray-700" data-id="element-58">{pain}</span>
                </li>)}
            </ul>

            <div className="mt-6 pt-5 border-t border-gray-100 text-center" data-id="element-59">
              <p className="text-lg font-semibold text-[#1e3a5f] mb-4" data-id="element-60">
                No es falta de amor.{' '}
                <span className="text-[#2563eb]" data-id="element-61">
                  Es falta de un material listo y bien guiado.
                </span>
              </p>
              <CTAButton variant="secondary" className="max-w-md mx-auto" data-id="element-62">
                <span className="flex items-center gap-2" data-id="element-63">
                  <Heart className="w-5 h-5" data-id="element-64" /> Necesito algo listo, claro y con
                  propósito
                </span>
              </CTAButton>
            </div>
          </div>
        </div>
      </section>

      {/* ===== SECTION 3: SOLUTION ===== */}
      <section className="py-10 px-4 bg-[#1e3a5f]" data-id="element-65">
        <div className="max-w-4xl mx-auto text-center" data-id="element-66">
          <div className="inline-block bg-[#d4a853] text-[#1e3a5f] text-sm font-bold px-4 py-1 rounded-full mb-3" data-id="element-67">
            ✨ LA SOLUCIÓN DEFINITIVA
          </div>

          <h2 className="text-3xl md:text-4xl font-black text-white mb-3" data-id="element-68">
            1001 Parábolas Kids
          </h2>
          <p className="text-xl text-blue-200 mb-6" data-id="element-69">
            La solución: enseñar con amor, sin improvisar
          </p>

          <p className="text-lg text-blue-100 max-w-3xl mx-auto mb-8 leading-relaxed" data-id="element-70">
            1001 Parábolas Kids es una colección completa de historias bíblicas
            ilustradas y actividades listas para usar, diseñada para ayudarte a
            guiar a los niños con calidez, fe y claridad. No es solo "material
            para imprimir". Es una forma simple de{' '}
            <strong className="text-white" data-id="element-71">
              crear momentos significativos, sembrar valores y mantener a los
              chicos interesados
            </strong>
            , sin tener que pasar horas buscando qué hacer cada semana.
          </p>

          {/* Benefits */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-8" data-id="element-72">
            {[{
            icon: CheckCircle,
            title: 'Todo listo',
            desc: 'Para imprimir'
          }, {
            icon: Sparkles,
            title: 'Todo probado',
            desc: 'Con niños reales'
          }, {
            icon: Calendar,
            title: 'Todo ordenado',
            desc: 'Por valores'
          }, {
            icon: Zap,
            title: 'Todo usable',
            desc: 'Sin preparación'
          }].map((benefit, i) => <div key={i} className="bg-white/10 backdrop-blur-sm rounded-xl p-3 border border-white/20" data-id="element-73">
                <benefit.icon className="w-7 h-7 text-[#d4a853] mx-auto mb-2" data-id="element-74" />
                <p className="font-bold text-white text-sm" data-id="element-75">{benefit.title}</p>
                <p className="text-blue-200 text-xs" data-id="element-76">{benefit.desc}</p>
              </div>)}
          </div>

          <CTAButton className="max-w-md mx-auto" data-id="element-77">
            <span className="flex items-center gap-2" data-id="element-78">
              <span data-id="element-79">👉</span> QUIERO ACCESO INMEDIATO{' '}
              <ArrowRight className="w-5 h-5" data-id="element-80" />
            </span>
          </CTAButton>
        </div>
      </section>

      {/* ===== SECTION 4: WHAT'S INCLUDED ===== */}
      <section className="py-10 px-4 bg-[#faf8f5]" data-id="element-81">
        <div className="max-w-5xl mx-auto" data-id="element-82">
          <div className="text-center mb-6" data-id="element-83">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1e3a5f] mb-2" data-id="element-84">
              ¿Qué incluye exactamente 1001 Parábolas Kids?
            </h2>
            <p className="text-lg text-gray-600" data-id="element-85">
              Una colección completa de historias y actividades para acompañar
              todo el año con fe, claridad y facilidad.
            </p>
          </div>

          {/* Content Grid */}
          <div className="grid md:grid-cols-2 gap-6 mb-8" data-id="element-86">
            {/* Left: Checklist */}
            <div className="bg-white rounded-2xl shadow-lg p-5 border border-gray-100" data-id="element-87">
              <div className="inline-block bg-[#e8f4fc] text-[#2563eb] text-sm font-bold px-3 py-1 rounded-full mb-3" data-id="element-88">
                +1000 Recursos Digitales
              </div>
              <ul className="space-y-2" data-id="element-89">
                {['Historias bíblicas ilustradas y adaptadas para niños', 'Parábolas con lenguaje simple, claro y cercano', 'Actividades imprimibles para reforzar cada enseñanza', 'Preguntas y reflexiones para conversar con los niños', 'Valores y aplicaciones prácticas para la vida cotidiana', 'Recursos para usar en casa, catequesis o escuela', 'Material ordenado para acompañar todo el año', 'Dinámicas para captar atención sin aburrir', 'Formato PDF listo para descargar e imprimir', 'Acceso inmediato a todo el material'].map((item, i) => <li key={i} className="flex items-start gap-2" data-id="element-90">
                    <CheckCircle2 className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-91" />
                    <span className="text-gray-700 text-sm" data-id="element-92">{item}</span>
                  </li>)}
              </ul>

              {/* Usage contexts */}
              <div className="mt-4 pt-3 border-t border-gray-100" data-id="element-93">
                <p className="text-sm text-gray-500 mb-2" data-id="element-94">Para usar en:</p>
                <div className="flex gap-2" data-id="element-95">
                  <span className="bg-blue-100 text-blue-700 text-xs font-medium px-3 py-1 rounded-full flex items-center gap-1" data-id="element-96">
                    <Home className="w-3 h-3" data-id="element-97" /> Casa
                  </span>
                  <span className="bg-purple-100 text-purple-700 text-xs font-medium px-3 py-1 rounded-full flex items-center gap-1" data-id="element-98">
                    <Church className="w-3 h-3" data-id="element-99" /> Catequesis
                  </span>
                  <span className="bg-green-100 text-green-700 text-xs font-medium px-3 py-1 rounded-full flex items-center gap-1" data-id="element-100">
                    <GraduationCap className="w-3 h-3" data-id="element-101" /> Escuela
                  </span>
                </div>
              </div>
            </div>

            {/* Right: Product Image */}
            <div className="flex items-center justify-center" data-id="element-102">
              <img src={IMAGES.product} alt="1001 Parábolas Kids" className="w-full max-w-xs drop-shadow-xl cursor-pointer" onClick={() => document.getElementById('seccion-compra')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-103" />
            </div>
          </div>

          {/* Highlighted Box */}
          <div className="bg-gradient-to-r from-[#1e3a5f] to-[#2563eb] rounded-2xl p-5 md:p-6 text-white mb-8" data-id="element-104">
            <h3 className="text-xl font-bold mb-3 text-center" data-id="element-105">
              Cada eje incluye 100 historias, lo que te permite:
            </h3>
            <div className="grid md:grid-cols-3 gap-3" data-id="element-106">
              <div className="bg-white/10 rounded-xl p-3 text-center" data-id="element-107">
                <span className="text-2xl mb-1 block" data-id="element-108">🗓️</span>
                <p className="font-medium text-sm" data-id="element-109">
                  Tener contenido para más de{' '}
                  <strong data-id="element-110">10 meses consecutivos</strong>
                </p>
              </div>
              <div className="bg-white/10 rounded-xl p-3 text-center" data-id="element-111">
                <span className="text-2xl mb-1 block" data-id="element-112">📖</span>
                <p className="font-medium text-sm" data-id="element-113">
                  Elegir una historia{' '}
                  <strong data-id="element-114">por día, semana o encuentro</strong>
                </p>
              </div>
              <div className="bg-white/10 rounded-xl p-3 text-center" data-id="element-115">
                <span className="text-2xl mb-1 block" data-id="element-116">🏠⛪🏫</span>
                <p className="font-medium text-sm" data-id="element-117">
                  Adaptarlo a <strong data-id="element-118">casa, catequesis o escuela</strong> sin
                  esfuerzo
                </p>
              </div>
            </div>
          </div>

          {/* 10 Axes */}
          <div className="bg-white rounded-2xl shadow-lg p-5 border border-gray-100" data-id="element-119">
            <h3 className="text-xl font-bold text-[#1e3a5f] mb-4 text-center" data-id="element-120">
              Los 10 ejes completos:
            </h3>
            <div className="grid md:grid-cols-2 gap-2" data-id="element-121">
              {CONTENT_AXES.map((axis, i) => <div key={i} className="flex items-center gap-3 bg-[#faf8f5] rounded-lg p-2.5" data-id="element-122">
                  <span className="text-xl" data-id="element-123">{axis.emoji}</span>
                  <div data-id="element-124">
                    <p className="font-semibold text-[#1e3a5f] text-sm" data-id="element-125">
                      100 Parábolas – {axis.title}
                    </p>
                    <p className="text-xs text-gray-500" data-id="element-126">{axis.desc}</p>
                  </div>
                </div>)}
            </div>
            <p className="text-center mt-4 text-[#2563eb] font-medium text-sm" data-id="element-127">
              Todo está organizado, claro y listo para que enseñes valores sin
              estrés, con amor y con propósito.
            </p>
          </div>
        </div>
      </section>

      {/* ===== SECTION 5: CAROUSEL ===== */}
      <section className="py-8 px-4 bg-[#f5f0e8]" data-id="element-128">
        <div className="max-w-5xl mx-auto" data-id="element-129">
          <h2 className="text-2xl md:text-3xl font-bold text-center text-[#1e3a5f] mb-1" data-id="element-130">
            Mirá una muestra del material por dentro
          </h2>
          <p className="text-center text-gray-600 mb-6" data-id="element-131">
            Diseñado para que los niños entiendan, participen y recuerden.
          </p>

          <ImageCarousel data-id="element-132" />
        </div>
      </section>

      {/* ===== SECTION 5.5: RESULTADOS REALES ===== */}
      <section className="py-10 px-4 bg-[#faf8f5]" data-id="element-133">
        <div className="max-w-5xl mx-auto" data-id="element-134">
          <div className="text-center mb-6" data-id="element-135">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1e3a5f] mb-1" data-id="element-136">
              Resultados Reales
            </h2>
            <p className="text-gray-600" data-id="element-137">
              El impacto inmediato en tu forma de enseñar y en el corazón de los
              niños
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-5" data-id="element-138">
            {/* Column 1: En los Niños */}
            <div className="bg-white rounded-2xl shadow-lg p-5 border border-gray-100" data-id="element-139">
              <div className="flex items-center gap-3 mb-4" data-id="element-140">
                <div className="w-10 h-10 bg-pink-100 rounded-full flex items-center justify-center" data-id="element-141">
                  <span className="text-xl" data-id="element-142">👧❤️</span>
                </div>
                <h3 className="text-lg font-bold text-[#1e3a5f]" data-id="element-143">
                  En los Niños…
                </h3>
              </div>
              <ul className="space-y-2" data-id="element-144">
                {['Comprenden valores sin aburrirse', 'Se conectan con historias que los emocionan', 'Participan más y hacen preguntas', 'Recuerdan el mensaje durante la semana', 'Se sienten acompañados, vistos y contenidos', 'Viven la fe de manera simple, alegre y cercana'].map((item, i) => <li key={i} className="flex items-start gap-2" data-id="element-145">
                    <CheckCircle2 className="w-5 h-5 text-pink-500 flex-shrink-0 mt-0.5" data-id="element-146" />
                    <span className="text-gray-700 text-sm" data-id="element-147">{item}</span>
                  </li>)}
              </ul>
            </div>

            {/* Column 2: Y en Vos */}
            <div className="bg-white rounded-2xl shadow-lg p-5 border border-gray-100" data-id="element-148">
              <div className="flex items-center gap-3 mb-4" data-id="element-149">
                <div className="w-10 h-10 bg-yellow-100 rounded-full flex items-center justify-center" data-id="element-150">
                  <span className="text-xl" data-id="element-151">🙋‍♀️✨</span>
                </div>
                <h3 className="text-lg font-bold text-[#1e3a5f]" data-id="element-152">Y en Vos…</h3>
              </div>
              <ul className="space-y-2" data-id="element-153">
                {['Dejás de improvisar cada encuentro', 'Ahorrás horas preparando material', 'Enseñás con calma, propósito y claridad', 'Tenés un camino completo para todo el año', 'Disfrutás más la catequesis o el tiempo en familia', 'Sentís que realmente estás dejando un legado'].map((item, i) => <li key={i} className="flex items-start gap-2" data-id="element-154">
                    <CheckCircle2 className="w-5 h-5 text-yellow-500 flex-shrink-0 mt-0.5" data-id="element-155" />
                    <span className="text-gray-700 text-sm" data-id="element-156">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* ===== SECTION 6: BONUSES ===== */}
      <section className="py-10 px-4 bg-[#f5f0e8]" data-id="element-157">
        <div className="max-w-5xl mx-auto" data-id="element-158">
          <div className="text-center mb-6" data-id="element-159">
            <div className="inline-block bg-red-500 text-white text-sm font-bold px-4 py-1 rounded-full mb-2" data-id="element-160">
              🎁 SOLO POR HOY
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-[#1e3a5f] mb-1" data-id="element-161">
              3 REGALOS EXCLUSIVOS
            </h2>
            <p className="text-gray-600" data-id="element-162">
              Valor total: <span className="line-through" data-id="element-163">$15.000</span>{' '}
              <span className="text-green-600 font-bold" data-id="element-164">GRATIS HOY</span>
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-4" data-id="element-165">
            {[{
            img: IMAGES.bonus1,
            title: 'Kit de Actividades Bíblicas para Colorear y Jugar',
            desc: 'Múltiples páginas con dibujos bíblicos, desafíos y juegos para reforzar valores jugando.'
          }, {
            img: IMAGES.bonus2,
            title: 'Devocional Padres & Hijos – 21 Días de Jornada con Dios',
            desc: 'Momentos simples y afectivos para fortalecer la fe en familia.'
          }, {
            img: IMAGES.bonus3,
            title: 'Juego de Memoria de las Parábolas (Imprimible)',
            desc: 'Tarjetas para jugar, recortar y memorizar contenidos bíblicos con alegría.'
          }].map((bonus, i) => <div key={i} className="bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-100 cursor-pointer hover:shadow-xl transition-shadow" onClick={() => document.getElementById('seccion-compra')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-166">
                <div className="relative p-3 bg-gray-50 flex items-center justify-center" data-id="element-167">
                  <img src={bonus.img} alt={bonus.title} className="w-[65%] h-auto object-contain" data-id="element-168" />
                  <div className="absolute top-2 right-2 bg-green-500 text-white text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-169">
                    GRATIS
                  </div>
                </div>
                <div className="p-3" data-id="element-170">
                  <p className="text-xs text-gray-400 mb-1" data-id="element-171">
                    Valor: <span className="line-through" data-id="element-172">$15.000</span>{' '}
                    <span className="text-green-600 font-semibold" data-id="element-173">
                      Gratis hoy
                    </span>
                  </p>
                  <h3 className="font-bold text-[#1e3a5f] mb-1 text-sm" data-id="element-174">
                    {bonus.title}
                  </h3>
                  <p className="text-xs text-gray-600" data-id="element-175">{bonus.desc}</p>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* ===== SECTION 7: PRICING ===== */}
      <section id="seccion-compra" className="py-10 px-4 bg-gradient-to-b from-[#1e3a5f] to-[#0f1f33] scroll-mt-8" data-id="element-176">
        <div className="max-w-2xl mx-auto" data-id="element-177">
          <div className="bg-white rounded-3xl shadow-2xl p-5 md:p-6 border-4 border-[#d4a853]" data-id="element-178">
            <div className="text-center mb-5" data-id="element-179">
              <h3 className="text-2xl md:text-3xl font-black text-[#1e3a5f] mb-3" data-id="element-180">
                1001 PARÁBOLAS KIDS
              </h3>
              <p className="text-gray-600 mb-3" data-id="element-181">
                Todo tu año resuelto en un solo pago
              </p>
              <div className="flex items-center justify-center gap-3 mb-2" data-id="element-182">
                <span className="text-gray-400 text-lg line-through" data-id="element-183">
                  Antes $66.990
                </span>
                <span className="bg-red-100 text-red-600 text-sm font-bold px-3 py-1 rounded-full" data-id="element-184">
                  AHORRÁ 70%
                </span>
              </div>
              <div className="text-5xl md:text-6xl font-black text-[#1e3a5f]" data-id="element-185">
                $19.990{' '}
                <span className="text-xl font-medium text-gray-500" data-id="element-186">ARS</span>
              </div>
              <p className="text-sm text-gray-500 mt-1" data-id="element-187">
                Pago único • Sin suscripciones
              </p>
            </div>

            <div className="bg-gradient-to-br from-[#faf8f5] to-[#f5f0e8] rounded-xl p-4 mb-5 border border-[#d4a853]/30" data-id="element-188">
              <p className="font-bold text-[#1e3a5f] mb-3 flex items-center gap-2 text-lg" data-id="element-189">
                <Sparkles className="w-5 h-5 text-[#d4a853]" data-id="element-190" /> Todo lo que
                incluye:
              </p>
              <ul className="space-y-2" data-id="element-191">
                {['Acceso a todo el contenido', '+1000 historias bíblicas ilustradas', 'Material listo para imprimir', 'Actividades + reflexiones + dinámicas', 'Colección organizada para todo el año', 'Guías para casa, escuela y catequesis', '3 Bonos Exclusivos GRATIS ($45.000 valor)', 'Acceso inmediato', 'Garantía 7 días'].map((item, i) => <li key={i} className="flex items-center gap-2 text-gray-700" data-id="element-192">
                    <CheckCircle2 className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-193" />
                    <span className="text-sm" data-id="element-194">{item}</span>
                  </li>)}
              </ul>
            </div>

            <CheckoutButton className="text-xl py-5" data-id="element-195">
              <span className="flex items-center gap-2" data-id="element-196">
                <span data-id="element-197">👉</span> SÍ, QUIERO MI KIT AHORA{' '}
                <ArrowRight className="w-6 h-6" data-id="element-198" />
              </span>
            </CheckoutButton>

            <p className="text-center text-sm text-gray-500 mt-3" data-id="element-199">
              Acceso inmediato después del pago • Garantía de devolución de 7
              días
            </p>

            <div className="mt-4 pt-3 border-t border-gray-200 text-center" data-id="element-200">
              <p className="text-amber-600 font-semibold flex items-center justify-center gap-2" data-id="element-201">
                <span data-id="element-202">⚠️</span> Quedan 3 cupos con este precio
              </p>
            </div>
          </div>

          <div className="text-center mt-6" data-id="element-203">
            <TrustBadges dark data-id="element-204" />
            <p className="text-blue-200 text-sm mt-4 mb-2" data-id="element-205">
              Pago 100% seguro procesado por:
            </p>
            <div className="flex items-center justify-center gap-4" data-id="element-206">
              <img src={IMAGES.mercadoLibre} alt="Mercado Libre" className="h-8 opacity-90 rounded" data-id="element-207" />
            </div>
            <div className="flex items-center justify-center gap-4 mt-3 text-blue-200 text-xs" data-id="element-208">
              <span className="flex items-center gap-1" data-id="element-209">
                <ShieldCheck className="w-4 h-4" data-id="element-210" /> Garantía 7 días
              </span>
              <span className="flex items-center gap-1" data-id="element-211">
                <Zap className="w-4 h-4" data-id="element-212" /> Acceso inmediato
              </span>
              <span className="flex items-center gap-1" data-id="element-213">
                <Users className="w-4 h-4" data-id="element-214" /> +500 confían
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* ===== SECTION 8: TESTIMONIALS ===== */}
      <section className="py-10 px-4 bg-[#faf8f5]" data-id="element-215">
        <div className="max-w-5xl mx-auto" data-id="element-216">
          <div className="text-center mb-6" data-id="element-217">
            <div className="flex items-center justify-center gap-1 mb-2" data-id="element-218">
              {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-6 h-6 fill-yellow-400 text-yellow-400" data-id="element-219" />)}
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-[#1e3a5f] mb-1" data-id="element-220">
              Lo que dicen padres, catequistas y docentes
            </h2>
            <p className="text-gray-600" data-id="element-221">
              Sumate a la comunidad que ya transformó su forma de enseñar
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-4" data-id="element-222">
            {TESTIMONIALS.slice(0, 3).map((t, i) => <div key={i} className="bg-white rounded-2xl shadow-lg p-5 border border-gray-100" data-id="element-223">
                <div className="flex items-center gap-3 mb-3" data-id="element-224">
                  <div className="w-10 h-10 bg-[#1e3a5f] rounded-full flex items-center justify-center text-white font-bold text-sm" data-id="element-225">
                    {t.initials}
                  </div>
                  <div data-id="element-226">
                    <p className="font-bold text-[#1e3a5f] text-sm" data-id="element-227">{t.name}</p>
                    <p className="text-xs text-gray-500" data-id="element-228">
                      {t.role} • {t.city}
                    </p>
                  </div>
                </div>
                <div className="flex gap-0.5 mb-2" data-id="element-229">
                  {[1, 2, 3, 4, 5].map(s => <Star key={s} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-230" />)}
                </div>
                <p className="text-sm text-[#2563eb] font-semibold mb-1" data-id="element-231">
                  {t.highlight}
                </p>
                <p className="text-gray-600 text-sm italic" data-id="element-232">"{t.text}"</p>
                <p className="text-xs text-green-600 mt-2 flex items-center gap-1" data-id="element-233">
                  <CheckCircle2 className="w-3 h-3" data-id="element-234" /> Compra verificada
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* ===== SECTION 9: GUARANTEE ===== */}
      <section className="py-10 px-4 bg-[#e8f4fc]" data-id="element-235">
        <div className="max-w-3xl mx-auto text-center" data-id="element-236">
          <div className="bg-white rounded-3xl shadow-lg p-6 border border-gray-100" data-id="element-237">
            <div className="w-16 h-16 bg-[#1e3a5f] rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-238">
              <ShieldCheck className="w-8 h-8 text-[#d4a853]" data-id="element-239" />
            </div>
            <h2 className="text-2xl md:text-3xl font-bold text-[#1e3a5f] mb-3" data-id="element-240">
              Garantía de Satisfacción "Sin Preguntas"
            </h2>
            <p className="text-gray-600 mb-6 max-w-xl mx-auto" data-id="element-241">
              Tenés 7 días completos para probar todo el material. Si por
              CUALQUIER razón sentís que no es lo que esperabas, te devolvemos
              el 100% de tu dinero.
            </p>
            <div className="flex items-center justify-center gap-6" data-id="element-242">
              {[{
              icon: ShieldCheck,
              text: 'Riesgo Cero'
            }, {
              icon: RefreshCw,
              text: 'Devolución Rápida'
            }, {
              icon: FileText,
              text: 'Sin Letra Chica'
            }].map((item, i) => <div key={i} className="flex flex-col items-center gap-2" data-id="element-243">
                  <div className="w-10 h-10 bg-[#e8f4fc] rounded-full flex items-center justify-center" data-id="element-244">
                    <item.icon className="w-5 h-5 text-[#2563eb]" data-id="element-245" />
                  </div>
                  <span className="text-sm font-medium text-[#1e3a5f]" data-id="element-246">
                    {item.text}
                  </span>
                </div>)}
            </div>
          </div>
        </div>
      </section>

      {/* ===== SECTION 10: FAQ ===== */}
      <section className="py-10 px-4 bg-[#faf8f5]" data-id="element-247">
        <div className="max-w-3xl mx-auto" data-id="element-248">
          <h2 className="text-3xl font-bold text-center text-[#1e3a5f] mb-6" data-id="element-249">
            Preguntas Frecuentes
          </h2>
          <div className="space-y-2" data-id="element-250">
            {FAQS.map((faq, i) => <div key={i} className="bg-white rounded-xl border border-gray-200 overflow-hidden" data-id="element-251">
                <button onClick={() => setOpenFaq(openFaq === i ? null : i)} className="w-full flex items-center justify-between p-4 text-left font-semibold text-[#1e3a5f] hover:bg-gray-50 transition-colors" data-id="element-252">
                  {faq.q}
                  {openFaq === i ? <ChevronUp className="w-5 h-5 text-[#2563eb]" data-id="element-253" /> : <ChevronDown className="w-5 h-5 text-gray-400" data-id="element-254" />}
                </button>
                {openFaq === i && <div className="px-4 pb-4 text-gray-600 border-t border-gray-100 pt-3" data-id="element-255">
                    {faq.a}
                  </div>}
              </div>)}
          </div>
          <p className="text-center text-gray-500 mt-4" data-id="element-256">
            ¿Tenés otra duda?{' '}
            <a href="#" className="text-[#2563eb] underline" data-id="element-257">
              Escribinos a soporte
            </a>
          </p>
        </div>
      </section>

      {/* ===== SECTION 11: FINAL CLOSE ===== */}
      <section className="py-10 px-4 bg-gradient-to-b from-[#1e3a5f] to-[#0f1f33]" data-id="element-258">
        <div className="max-w-2xl mx-auto text-center" data-id="element-259">
          <Heart className="w-14 h-14 text-[#d4a853] mx-auto mb-4" data-id="element-260" />
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-4 leading-relaxed" data-id="element-261">
            Enseñar valores no debería sentirse como una carga.
          </h2>
          <p className="text-lg text-blue-200 mb-6 leading-relaxed" data-id="element-262">
            Con 1001 Parábolas Kids vas a poder guiar a los niños con amor, fe y
            claridad — sin improvisar y sin buscar material cada semana.
            <br data-id="element-263" />
            <br data-id="element-264" />
            <strong className="text-white" data-id="element-265">
              Es un legado hermoso… y ahora también es fácil.
            </strong>
          </p>
          <CTAButton className="max-w-md mx-auto text-xl py-5" data-id="element-266">
            <span className="flex items-center gap-2" data-id="element-267">
              <span data-id="element-268">👉</span> QUIERO ACCEDER AHORA{' '}
              <ArrowRight className="w-6 h-6" data-id="element-269" />
            </span>
          </CTAButton>
          <TrustBadges dark data-id="element-270" />
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#0f1f33] text-gray-400 py-6 text-center text-sm" data-id="element-271">
        <p data-id="element-272">© 2025 1001 Parábolas Kids. Todos los derechos reservados.</p>
        <p className="mt-1" data-id="element-273">Hecho con ❤️ para familias cristianas.</p>
      </footer>

      {/* Social Proof Popup */}
      <SocialProofPopup data-id="element-274" />
    </div>;
}